export class EoFormControlBlock {
    name: string;
    label: string;
    type: string;
    isMandatory: boolean;
    placeholder: string;
    url: string;
  
    constructor(name: string, label: string, type: string, isMandatory: boolean,
      placeholder: string, url: string){
      this.name = name;
      this.label = label;
      this.type = type;
      this.isMandatory = isMandatory;
      this.placeholder = placeholder;
      this.url = url;
    }
  }
  